const retry = require("../../utils/retry");

const statusCodes = {
  SESSION_CONTEXT_SUCCESS: "SESSION_CONTEXT_SUCCESS",
  SESSION_CONTEXT_FAIL: "SESSION_CONTEXT_FAIL",
};

const getSessionContextPromise = () =>
  new Promise((resolve, reject) => {
    if (window.ikea && window.ikea.getSession) {
      const option = { baseUrl: CONFIG.iowsSessionContextBaseUrl };
      const [retailId, languageCode] = CONFIG.iowsLocale.split("/");
      if (retailId) {
        option.retailId = retailId;
      }
      if (languageCode) {
        option.languageCode = languageCode;
      }
      window.ikea.getSession((error, sessionContext) => {
        if (error) reject(error);
        else resolve(sessionContext);
      }, option);
    } else {
      reject(new Error("getSession is not found"));
    }
  });

const oneWebIrwSessionContext = () => {
  return retry(getSessionContextPromise, 3000, 3)
    .then((json) => {
      return {
        status: statusCodes.SESSION_CONTEXT_SUCCESS,
        userId: json.userId,
        userType: json.userType,
      };
    })
    .catch((error) => {
      return {
        status: statusCodes.SESSION_CONTEXT_FAIL,
        error,
      };
    });
};

export default oneWebIrwSessionContext;
